import { useCallback } from 'react';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerPause } from './usePlayerPause';
import { usePlayerPlay } from './usePlayerPlay';

export const usePlayerPlayPause = () => {
  const videoElement = usePlayerStore((state) => state.videoElement);
  const { onPlayerPlay } = usePlayerPlay();
  const { onPlayerPause } = usePlayerPause();

  const onPlayerPlayPause = useCallback(() => {
    if (videoElement) {
      if (videoElement.paused) {
        onPlayerPlay();
      } else {
        onPlayerPause();
      }
    }
  }, [videoElement, onPlayerPlay, onPlayerPause]);

  return { onPlayerPlayPause };
};
